import { motion } from "framer-motion";
import { SpinReel } from "./SpinReel";
import { CharacterGrid } from "./CharacterGrid";
import { REVEAL_POP } from "./motionPresets";

const Idle = ({ filled }) => (
  <div className="reel-window reel-idle" data-testid="spin-idle">
    <p className="reel-label font-display text-[#5E5E8A]">
      {filled === 0 ? "? ? ?" : "Prossima ciurma"}
    </p>
  </div>
);

const STAGE_LABELS = { choose: "Estrazione completata", spinning: "Estrazione in corso" };

export const Stage = ({ game, selectedId, onSelect }) => {
  const { phase, crew, finishSpin, isAvailable, filledCount } = game;
  return (
    <section className="mb-7" data-testid="stage">
      <p className="label-mono text-[#7433C1] mb-3">{STAGE_LABELS[phase] ?? "Lumacofono in attesa"}</p>
      {phase === "spinning" && <SpinReel target={crew} onDone={finishSpin} />}
      {phase === "choose" && (
        <>
          <motion.div
            className="reel-window reel-revealed flex-col !items-start justify-center gap-1.5 py-4"
            {...REVEAL_POP}
          >
            <span
              className="font-display text-xs tracking-[0.14em] text-white bg-[#F26DB5] rounded-full px-3 py-1"
              data-testid="crew-revealed-label"
            >
              È USCITA:
            </span>
            <h2 className="reel-label font-display text-[#14233D]" data-testid="crew-revealed-name">
              {crew.name}
            </h2>
          </motion.div>
          <p className="text-sm text-[#14233D]/80 mt-6 mb-3">Scegli un personaggio da arruolare.</p>
          <CharacterGrid crew={crew} isAvailable={isAvailable} selectedId={selectedId} onSelect={onSelect} />
        </>
      )}
      {(phase === "ready" || phase === "complete") && <Idle filled={filledCount} />}
    </section>
  );
};
